<template>
  <div v-if="showList">
    <h4 class="mb-2 text-dark">{{ list.title }}</h4>
    <div class="row">
      <div
        v-for="item in filteredItems"
        :key="item.variantId"
        class="d-flex col-md-12 col-lg-8 mb-1 mb-sm-2"
      >
        <Item :item="item" />
      </div>
    </div>
  </div>
</template>

<script>
import Item from "./ProductEssentialItem";
import { mapGetters, mapActions } from "vuex";

export default {
  name: "EssentialsList",
  components: {
    Item,
  },
  props: {
    list: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapGetters({
      activeVendorFilter: "lists/vendorFilter",
    }),
    filteredItems() {
      return this.applyFilters(this.list.items);
    },
    vendors() {
      return [...new Set(this.list.items.map(item => item.vendor))];
    },
    showList() {
      return this.activeVendorFilter ? this.vendors.includes(this.activeVendorFilter) : true;
    },
  },
  mounted() {
    this.setFilterableVendors(this.vendors);
  },
  methods: {
    ...mapActions({
      setFilterableVendors: "lists/setFilterableVendors",
    }),
    applyFilters(items) {
      items = this.vendorFilter(items);
      items = this.productNameFilter(items);
      return items;
    },
    vendorFilter(items) {
      return items.filter(item =>
        this.activeVendorFilter ? item.vendor === this.activeVendorFilter : true
      );
    },
    productNameFilter(items) {
      return items;
    },
  },
};
</script>
